import axios from 'axios';
import { VEHICLE_TYPE_MAPPER, TRANSACTION_TYPE_MAPPER, PLATE_TYPE_FULL_TO_SHORT } from '../../components/fees/contants';

const SERVER_URL = process.env.REACT_APP_API_URL;

export const Api = {
  getCsrfToken: async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/get-csrf-token`, {
        withCredentials: true,
      });
      return response.data.csrf_token;
    } catch (e) {
      console.error('Error fetching CSRF token:', e);
      throw new Error('Failed to get CSRF token.');
    }
  },


  decodeZip: async (data) => {
    const { zipValue } = data
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/decode-zip`, {
        zip: zipValue,
      },{
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true
      });

      switch (response.status) {
        case 200:
          return response;
        case 401:
          throw new Error('Invalid email or password!');
        case 404:
          throw new Error('User does not exists!');
        case 400:
          throw new Error('All fields required!');
        default:
          throw new Error('Something went wrong!');
      }
    } catch (e) {
      console.log("Error", e);
    }
  },

  decodeVin: async (data) => {
    const { vin } = data
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/decode-vin`, {
        vin: vin,
      }, {
        headers:{
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true
      });

      switch (response.status) {
        case 200:
          return response;
        case 401:
          throw new Error('Invalid email or password!');
        case 404:
          throw new Error('User does not exists!');
        case 400:
          throw new Error('All fields required!');
        default:
          throw new Error('Something went wrong!');
      }
    } catch (e) {
      console.log("Error", e);
    }
  },

  submitFee: async (data) => {
    try {
      const payload = {
        "": "T",
        ZIP: data.zipCode,
        zip: data.zipCode,
        City: data.city,
        city: data.city,
        County: data.country,
        county: data.country,
        State: data.state,
        state: data.state,
        VIN: data.vinCode,
        vinNumber: data.vinCode,
        VehicleType: VEHICLE_TYPE_MAPPER[data.vehicleType],
        vehicleType: data.vehicleType,
        FuelType: data.fuelType,
        fuelType: data.fuelType,
        modelYear: data.modelYear,
        Weight: data.vehicleWeight || "3000",
        MSRP: data.msrp,
        gvw: data.gvw,
        BasePrice: data.basePrice,
        PlateType: PLATE_TYPE_FULL_TO_SHORT[data.plateType],
        TransactionType: TRANSACTION_TYPE_MAPPER[data.transactionType],
        TitleStatus: data.titleStatus,
        OutsideCityLimits: data.outSideCityLimit ? "1" : "0",
        IsTransfer: data.plateTransfer ? "1" : "0",
        GVW: data.gvm,
        CustomerType: "F",
        LienStatus: "1",
      }

      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/fees-api-callV2`, payload, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true,
      });


      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },
}
